import request from '@/plugin/axios'
export function getNoticePagedList(query) {
    return request({
        url: '/moblieapp/noticePagedlist',
        method: 'post',
        params: query
    })
}
export function delNotice(data) {
    return request({
        url: '/moblieapp/noticeDel',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '操作成功',
                type: 'success'
            }
        }
    })
}

export function delNotices(data) {
    return request({
        url: '/moblieapp/noticesDel',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '操作成功',
                type: 'success'
            }
        }
    })
}
export function saveNotice(data) {
    return request({
        url: '/moblieapp/NoticeSave',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}
